import React from 'react';

import AssessmentTab from 'containers/RiskAssessmentsDetails/AssessmentTab';

import RiskAssessmentDetailsStore from 'stores/RiskAssessmentDetails';

import { TabComponentProps } from '../types';

const AssessmentTabWrapper: React.FC<TabComponentProps> = ({ store, ...props }) => (
  // Type assertion here is safe because this component will only be rendered
  // when we know we're dealing with a RiskAssessmentDetailsStore
  <AssessmentTab store={store as RiskAssessmentDetailsStore} {...props} />
);

export default AssessmentTabWrapper;
